import { TTheme } from "../models/types/Theme.types";

let params = new URLSearchParams(document.location.search);

export const SITE_NAME = process.env.REACT_APP_SITE_NAME as string;
// export const SITE_URL = process.env.REACT_APP_SITE_URL as string;
// export const SITE_DESCRIPTION = process.env
//   .REACT_APP_SITE_DESCRIPTION as string;
// export const SITE_FAVICON = process.env.REACT_APP_SITE_FAVICON as string;
// export const SITE_LOGO = process.env.REACT_APP_SITE_LOGO as string;
export const CURRENCY = process.env.REACT_APP_CURRENCY as string;
export const TIMEZONE = "UTC";

// DO NOT CHANGE THE FOLLOWING SETTINGS
export const BACKEND_URL_PROTOCOL = process.env
  .REACT_APP_BACKEND_URL_PROTOCOL as string; // http:// or https://
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string; // Without https:// or http:// prefix
export const API_VERSION = process.env.REACT_APP_API_VERSION as string;
export const THEME: TTheme = "default";
export const CLIENT_ID = params.get("client_number") as string;
export const APP_SECRET_KEY = process.env.REACT_APP_APP_SECRET_KEY as string;
export const APP_PRIVATE_KEY = process.env.REACT_APP_IV_PRIVATE_KEY as string;
export const REACT_APP_ENCRYPTION_SPLITER = process.env
  .REACT_APP_ENCRYPTION_SPLITER as string;
export const REACT_APP_METRICOOL_URL = process.env
  .REACT_APP_METRICOOL_URL as string;
export const REACT_APP_METRICOOL_URL_TWO = process.env
  .REACT_APP_METRICOOL_URL_TWO as string;
export const REACT_APP_STORAGE_BASE_URL = process.env
  .REACT_APP_STORAGE_BASE_URL as string;
// END OF DO NOT CHANGE SETTINGS

export const SHORTLISTED_PROGRAMS_FILENAME = process.env
  .REACT_APP_PROGRAMS_CSV_FILENAME as string;

export const LEAD_FORM_ID = process.env.REACT_APP_LEAD_FORM_ID as string;
export const AGENT_FORM_ID = process.env.REACT_APP_AGENT_FORM_ID as string;
export const APPLICATION_FORM_ID = process.env
  .REACT_APP_APPLICATION_FORM_ID as string;
export const WHATSAPP_APP_ID = process.env.REACT_APP_WHATSAPP_APP_ID as string;
export const WHATSAPP_CONNECT_DOMAIN = process.env
  .REACT_APP_WHATSAPP_CONNECT_DOMAIN as string;
export const WHATSAPP_CONFIG_ID = process.env
  .REACT_APP_WHATSAPP_CONFIG_ID as string;
export const WHATSAPP_SDK_VERSION = process.env
  .REACT_APP_WHATSAPP_SDK_VERSION as string;
export const CREATE_LEAD_FORM_ID = "LFO1716112595567K56USAHJ04";
export const PER_PAGE_SIZE = 15;
export const MESSAGES_PER_PAGE = 15;
export const EMPTY_STATE_PLACEHOLDER = "--";
export const PHONE_EMPTY_PLACEHOLDER = "XXXXXXXXXX";
export const DATE_EMPTY_PLACEHOLDER = "----/--/--";
export const UNIVERSITY_LIVING_WIDGET_ID = process.env
  .REACT_APP_UNIVERSITY_LIVING_WIDGET_ID as string;
export const SHOW_COLABLI = process.env.REACT_APP_SHOW_COLABLI;
export const SHOW_AI_ADVISOR = process.env.REACT_APP_SHOW_AI_ADVISOR;
export const SHOW_AGENTLI = process.env.REACT_APP_SHOW_AGENTLI;
export const SHOW_MARKETLI = process.env.REACT_APP_SHOW_MARKETLI;
export const SHOW_GENERAL_CAMPAIGNS =
  process.env.REACT_APP_SHOW_MARKETLI_GENERAL_CAMPAIGN;
export const SHOW_WHATSAPP_CAMPAIGNS =
  process.env.REACT_APP_SHOW_MARKETLI_WHATSAPP_CAMPAIGN;
export const SHOW_EMAIL_CAMPAIGNS =
  process.env.REACT_APP_SHOW_MARKETLI_EMAIL_CAMPAIGN;
export const SHOW_SOCIAL_MEDIA =
  process.env.REACT_APP_SHOW_MARKETLI_SOCIAL_MEDIA;
export const SHOW_SEGMENTS = process.env.REACT_APP_SHOW_MARKETLI_SEGMENTS;
export const SHOW_TEMPLATES = process.env.REACT_APP_SHOW_MARKETLI_TEMPLATES;

export const CURRENCIES = [
  {
    label: "AUD",
    value: "aud",
  },
  {
    label: "CAD",
    value: "cad",
  },
  {
    label: "INR",
    value: "inr",
  },
  {
    label: "USD",
    value: "usd",
  },
  {
    label: "EUR",
    value: "eur",
  },
  {
    label: "GBP",
    value: "gbp",
  },
  {
    label: "NZD",
    value: "nzd",
  },
  {
    label: "SGD",
    value: "sgd",
  },
];

export const CURRENT_DEVELOPMENT_MODE = process.env.NODE_ENV;

export const LO_ACADEMIC_LINES = {
  "10": {
    year: "Passed 10th grade in {1}",
    grade: "Passed 10th grade with an {2} Grade.",
    both: "Passed 10th grade in {1} with an {2} Grade.",
  },
  "12": {
    year: "Passed 12th grade in {1}",
    grade: "Passed 12th grade with an {2} Grade.",
    both: "Passed 12th grade in {1} with an {2} Grade.",
  },
  bachelor: {
    year: "Graduated in {1}",
    grade: "Graduated with an {2} Grade.",
    both: "Graduated in {1} with an {2} Grade.",
  },
  master: {
    year: "Post Graduated in {1}",
    grade: "Post Graduated with an {2} Grade.",
    both: "Post Graduated in {1} with an {2} Grade.",
  },
  get: function (
    type: "10" | "12" | "bachelor" | "master",
    year: string,
    grade: string
  ) {
    if (year && grade) {
      return this[type].both.replace("{1}", year).replace("{2}", grade);
    }

    if (year && !grade) {
      return this[type].year.replace("{1}", year);
    }

    if (grade && !year) {
      return this[type].grade.replace("{2}", year);
    }
  },
};
export const B2B_AND_B2C = process.env.REACT_APP_B2B_AND_B2C as string;

export const UNDER_DEVELOPMENT = true;

export const FORM_FIELD_APIS_LIST = [
  {
    label: "Country",
    value: "/dropdown/country?identifier_only=true",
    params: [],
  },
  {
    label: "Destination Countries",
    value: "/dropdowns/destination-countries-dropdown?number_only=true",
    params: [],
  },
  { label: "State", value: "/dropdown/state", params: ["country_id"] },
  { label: "City", value: "/dropdown/city", params: ["state_id"] },
  { label: "Campus", value: "/dropdown/campus", params: ["city_id"] },
  { label: "Study Level", value: "/dropdown/studylevel", params: [] },
  { label: "Discipline", value: "/dropdown/discipline", params: [] },
  { label: "Test Score", value: "/dropdown/testscore", params: [] },
  { label: "Intake", value: "/dropdown/intake", params: [] },
  { label: "Institutions", value: "/dropdown/institution", params: [] },
  { label: "Status", value: "/status/dropdown", params: [] },
  {
    label: "Code With Country Name",
    value: "/dropdowns/countries/codes-dropdown?text_only=true",
    params: [],
  },
];
